export default "__VITE_ASSET__67e8Cl6G__"